import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
const HEALTH_TIMEOUT_MS = 5000;
const UNAVAILABLE_STATUSES = [502, 503, 504];

/**
 * True when the error means the server is unreachable (not a business/auth error).
 * Cloudflare 502/504 pages come without CORS headers, so the browser usually reports them
 * as a network error with no `response` at all — both cases are treated the same.
 */
export function isServerUnavailableError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  if (!error.response) return true;
  return UNAVAILABLE_STATUSES.includes(error.response.status);
}

/** Pings /health with plain axios (no interceptors) — never throws. */
export async function checkServerHealth(): Promise<boolean> {
  try {
    await axios.get(`${API_BASE}/health`, {
      timeout: HEALTH_TIMEOUT_MS,
      params: { t: Date.now() }, // avoid any proxy/CDN cache
    });
    return true;
  } catch {
    return false;
  }
}
